import VendorLoginSection from './VendorLoginSection';

export default VendorLoginSection;
